export default __webpack_public_path__ + "static/media/postman.a5c540be.png";